import styled from "styled-components";

export const SCreateProjectModalFirstStepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  height: 100%;
`;
